// First run: choose the app's language. Each option is named in its own script, and the rest of
// the screen is in the browser's language (or English), so nothing is shown in two languages.
// The choice is saved to the account, so the Instagram bot replies in it too. Settings changes it.
import { useState } from 'preact/hooks';
import { api, ApiError } from '../api';
import { applyLang, getLang, uiLang, useT, type Lang } from '../i18n';
import { LANGUAGES, langAttr } from '../languages';

export function LanguagePick({ onDone }: { onDone: (l: Lang) => void }) {
  const t = useT();
  const [choice, setChoice] = useState<Lang>(() => getLang() || (uiLang() as Lang));
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const go = async () => {
    setBusy(true);
    setErr('');
    try {
      await api.setLanguage(choice);
      applyLang(choice);
      onDone(choice);
    } catch (e) {
      const ae = e as ApiError;
      setErr(ae.status === 0 ? t('lang.saveFailed') : ae.message);
      setBusy(false);
    }
  };
  return (
    <div class="page" style="padding:24px 20px 28px">
      <div class="wordmark">eat<span>.</span>recipe</div>
      <div style="margin-top:32px;display:flex;flex-direction:column;gap:6px">
        <h1 class="h1" style="font-size:30px;line-height:1.3">{t('lang.title')}</h1>
        <p class="muted" style="margin:6px 0 0;line-height:1.6">{t('lang.body')}</p>
      </div>
      <div role="radiogroup" aria-label={t('lang.title')} style="margin-top:20px;display:flex;flex-direction:column;gap:8px">
        {LANGUAGES.map((o) => (
          <button class="lang-option" role="radio" aria-checked={choice === o.lang} aria-pressed={choice === o.lang} onClick={() => setChoice(o.lang)} lang={langAttr(o.lang)}>
            <span class="radio" aria-hidden="true" />
            <span style="display:flex;flex-direction:column;gap:2px">
              <span class="display" style="font-weight:800;font-size:19px">{o.name}</span>
              <span class="small muted" style="line-height:1.45">{o.about}</span>
            </span>
          </button>
        ))}
      </div>
      {err && <div class="error-text" role="alert" style="margin-top:12px">{err}</div>}
      <div style="position:sticky;bottom:0;margin-top:auto;padding-top:20px;background:var(--ground)">
        <button class="btn btn-primary btn-lg" style="width:100%" disabled={busy} onClick={go}>{t('lang.continue')}</button>
      </div>
    </div>
  );
}
